export type LanguageCode = 'en' | 'nl';

type Language = {
	code: LanguageCode;
	file: `${LanguageCode}.ts`;
};

const languages: Language[] = [
	{
		code: 'en',
		file: 'en.ts',
	},
	{
		code: 'nl',
		file: 'nl.ts',
	},
];
export default languages;
